/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Result_Heading_SingularInputs */

const en_matching_score_result_heading_singular = /** @type {(inputs: Matching_Score_Result_Heading_SingularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result: Your matching score`)
};

const de_matching_score_result_heading_singular = /** @type {(inputs: Matching_Score_Result_Heading_SingularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnis: Dein Matching-Score`)
};

/**
* | output |
* | --- |
* | "Result: Your matching score" |
*
* @param {Matching_Score_Result_Heading_SingularInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_result_heading_singular = /** @type {((inputs?: Matching_Score_Result_Heading_SingularInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Result_Heading_SingularInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_result_heading_singular(inputs)
	return en_matching_score_result_heading_singular(inputs)
});